











































































import Vue from 'vue'

export default Vue.extend({
  name: 'ConfidenceLevel',
  props: {
    type: {
      type: String,
      default: 'global'
    }
  },
  data: () => ({
    levels: [
      { name: 'Alto', class: 'high' },
      { name: 'Medio', class: 'medium' },
      { name: 'Bajo', class: 'low' }
    ]
  })
})
